import React, {useState, useEffect, Fragment} from 'react';
import { withCookies, useCookies } from 'react-cookie';
import Button from '../UI/Button/Button';
import { postEvent } from '../../utils/helpers';

const Stats = (props) => {

    const [cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8STATS']);

    let data;
    if(props.data) {
        data = props.data; 
    } else if (cookies.A8STATS) {
        data = cookies.A8STATS;
    } else {
        data =  {
            played : 0,
            correct : 0,
            streak : 0,
            max : 0
        }
    }

    const showShareButton = props.sharedStats ? false : true;
    const showDescription = props.sharedStats ? true : false;
    const height = props.sharedStats ? "270px" : "212px";    

    const sharedAt = props.sharedAt ? (new Date(props.sharedAt)) : null;

    const viewOwnScore = () => {
        window.open('stats', '_self');
    }

    const shareStats = () => {
        const dataJson = JSON.stringify(data);
        const url = '/stats?src=' + btoa(dataJson) + '&shared_at=' + (new Date()).getTime();
        const event = {
            category: "end-user-action",
            subcategory : "sweepstakes",
            action : "share-stats",
            label : dataJson,
            content_id : props.content.pivot?.content_id,
            client_id : props.content.client_id,
            campaign_id : props.content.pivot?.campaign_id,
            trigger_id : props.content.pivot?.trigger_id
        }
        
        if(window.location.protocol === 'https:') {
            postEvent(props.device, event);
            navigator.share({
                url : url,
                text : process.env.REACT_APP_SWEEPSTAKES_STATS_MODULE_SHARE_TEXT,
                title : process.env.REACT_APP_META_TITLE
            })
        } else {
            console.log(event);
            alert('Sharing through native share tray. Values: URL= ' + url + ', TEXT=' + process.env.REACT_APP_SWEEPSTAKES_STATS_MODULE_SHARE_TEXT);
        }
    }

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const statsModule = 
        <div style={{
            color: "black", 
            backgroundColor: "white", 
            fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
            width: "88%", 
            marginLeft: "auto", 
            marginRight: "auto", 
            display: "block",
            borderRadius: "8px",
            paddingBottom: "20px",
            paddingTop: "20px",
            marginTop: "20px", 
            height: 'auto'
            }}>
            <h1 style={{marginBottom: "10px"}}>{props.sharedStats ? 'Shared Score' : 'Your Score'}</h1>
            {sharedAt && <h3 style={{color: "#7D7D7D", marginBottom: "40px", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY, fontSize: "14px", fontWeight: "500"}}>shared on {months[sharedAt.getMonth()]} {sharedAt.getDate()}, {sharedAt.getFullYear()}</h3>}
            <div style={{display: "block", height: "auto", marginBottom: "30px", marginTop: "30px"}}>
                <div style={{width: "25%", float:"left", textAlign: "center", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY, fontWeight: "600", fontSize: "24px", marginBottom: "20px"}}>
                    <span>{data.played}</span><br/>
                    <span style={{fontSize: "15px", fontWeight: "400"}}>Played</span>
                </div>
                <div style={{width: "25%", float:"left", textAlign: "center", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY, fontWeight: "600", fontSize: "24px", marginBottom: "20px"}}>
                    <span>{(data.played) ? ((data.correct / data.played) * 100).toFixed(0) : 0}%</span><br/>
                    <span style={{fontSize: "15px", fontWeight: "400"}}>Win %</span>
                </div>
                <div style={{width: "25%", float:"left", textAlign: "center", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY, fontWeight: "600", fontSize: "24px", marginBottom: "20px"}}>
                    <span>{data.streak}</span><br/>
                    <span style={{fontSize: "15px", fontWeight: "400"}}>Streak</span>
                </div>
                <div style={{width: "25%", float:"left", textAlign: "center", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY, fontWeight: "600", fontSize: "24px", marginBottom: "20px"}}>
                    <span>{data.max}</span><br/>
                    <span style={{fontSize: "15px", fontWeight: "400"}}>Max</span>
                </div>
            </div>

            {showDescription && 
            <div style={{marginTop: "35px", textAlign: "center", display: "block", width: "85%", marginLeft: "auto", marginRight: "auto", fontSize: "16px", lineHeight: "26px", fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY, fontWeight: "500"}}>
                <p>Someone shared their score for the <br/><span style={{fontWeight: "bold", textTransform: "uppercase"}}>{process.env.REACT_APP_NAME} AT HOME GAME</span>.<br/>Think you can do better?</p>
            </div>
            }

            <div style={{width:"88%", marginLeft:"auto", marginRight: "auto", paddingBottom: "20px"}}>
                <Button 
                    style={{
                        fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                        fontSize: "18px",
                        fontWeight: "800",
                        letterSpacing: 0.5,
                        lineHeight: "21px",
                        textTransform: "uppercase",
                        color: process.env.REACT_APP_NAME_FONT_COLOR,
                        marginTop: "10px",
                        height: "50px",
                        width: "96%",
                        borderRadius: "10px",
                        border: process.env.REACT_APP_BUTTON_TRANSPARENT,
                        backgroundColor : "#fff"
                    }}
                    onClick={sharedAt ? viewOwnScore : shareStats} 
                    btnText={sharedAt ? 'View Your Score' : 'Share'}/>
            </div>

        </div>    

    const whereToWatchModule = 
        <div style={{
            color: "black", 
            backgroundColor: "white", 
            fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY,
            width: "88%", 
            marginLeft: "auto", 
            marginRight: "auto", 
            display: "block",
            borderRadius: "8px",
            paddingBottom: "20px",
            paddingTop: "20px",
            marginTop: "20px", 
            height: 'auto'
            }}>
                <h1 style={{marginBottom: "10px"}}>Where to Watch</h1>
                <p style={{fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, fontSize: "16px", lineHeight: "26px", paddingLeft: "15%", paddingRight: "15%" }}>Watch <span style={{color: process.env.REACT_APP_NAME_FONT_COLOR ?? "#2D75FF"}}>{process.env.REACT_APP_NAME}</span> on FOX and you'll have a chance to play along at home, too!</p>
                <div style={{width:"88%", marginLeft:"auto", marginRight: "auto", paddingBottom: "20px"}}>
                <Button 
                    style={{
                        fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                        fontSize: "18px",
                        fontWeight: "800",
                        letterSpacing: 0.5,
                        lineHeight: "21px",
                        textTransform: "uppercase",
                        color: "#fff",
                        marginTop: "10px",
                        height: "50px",
                        width: "96%",
                        borderRadius: "10px",
                        border: "#2D75FF 1px solid",
                        backgroundColor : "#2D75FF"
                    }}
                    onClick={() => window.open(process.env.REACT_APP_WHERE_TO_WATCH_URL)} 
                    btnText={'WHERE TO WATCH'}/>
            </div>                

        </div>
    return (
        <div>
            {statsModule}
            {(sharedAt && process.env.REACT_APP_WHERE_TO_WATCH_URL) && whereToWatchModule}
        </div>
    )
} 

export default Stats;